import { render, staticRenderFns } from "./MessagePreviewCombined.vue?vue&type=template&id=44072710"
import script from "./MessagePreviewCombined.vue?vue&type=script&lang=js"
export * from "./MessagePreviewCombined.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports